<script lang="ts" setup>
import { useService } from '@kaokei/use-vue-service';
import icon from '@/assets/image/im/icon-emoji.svg';
import ActionBtn from './ActionBtn.vue';
import { EmojiActionService } from './EmojiAction.service';

const emojiActionService = useService(EmojiActionService);
</script>

<template>
  <ActionBtn
    v-track:oj_click_im_window_emoji.click
    :icon="icon"
    text="表情"
    @click="emojiActionService.toggleVisible"
  />
</template>
